module.exports = __webpack_public_path__ + "static/media/warning.20d54c88.svg";